import settings from '@/data/constants';
import { patientIhiContract } from '@montugroup/pms-api-contracts';
import { createQueryClient } from '../queryClient.util';

// @todo upgrade to new Xapi contracts
const patientIhiClient = () => createQueryClient({ contract: patientIhiContract, baseUrl: settings.url });

export { patientIhiClient };
